import { useState, useEffect } from 'react';

export function useInsights() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      // Cache-busting query param
      const response = await fetch(`/data/latest_insights.json?t=${Date.now()}`);
      
      if (!response.ok) throw new Error('Failed to load data');
      
      const result = await response.json();
      setData(result);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000); // Auto-refresh every 30s
    return () => clearInterval(interval);
  }, []);

  return { data, loading, error };
}
